module.exports = __webpack_public_path__ + "img/great-white-pelican.1f515f4b.jpg";